import { DeviceConnectMode } from '@libs/types/enum'
import {
  DefineDevice,
  VirtualHE3SEWireless_24g,
  VirtualHE3SEWireless,
  VirtualMu68Pro,
  VirtualNa87ProWired,
  VirtualNd63,
  VirtualMu68Pro_Cyan,
  VirtualNd63_Cyan,
  VirtualMu68_ULTRA,
  VirtualPolar75,
  VirtualMars68ProWireless,
  VirtualMars68ProWireless_24g as VirtualMars68ProWireless_24g,
  VirtualMonsGeek_NoLight,
  VirtualMonsGeek_NoLight_24g,
  VirtualMars68Wireless,
  VirtualMars68Wireless_24g,
  VirtualMg68Max,
  VirtualMg68Max_24g,
  RoYuanDevice,
  JingTaiMg75Devices,
  JingTaiMer68Devices,
  VirtualHe6Ultra,
  VirtualHe6Ultra_24g,
  JingTaiV2Devices,
  VirtualMG68ACE_W,
  VirtualMG68ACE_W_24g,
  VirtualIrokFe87V2,
  VirtualIrokFe87V2_24g,
  VirtualMer68SESelfDev,
  VirtualIrokFe87V2IMC,
  VirtualIrokFe87V2IMC_24g,
  VirtualIrokFe87V2C18,
  HuoChaiRenDevices,
  ZhiHuiWuXian_Device,
} from './define'
import { DeviceModel, SupportData } from './device'

class he3Model implements DeviceModel {
  name: string = 'HE3 SE'
  support: SupportData = {
    IsSupportMagnet: false,
    Limit: {
      DpiLen: 6,
      KeySetLen: 0,
      KeysColorLen: 0,
      MacroBytesLen: 152,
      MacroIndexLen: 8,
      MacroPrefix: [],
      MagnetLen: 0,
    },
  }
}

class na87Model implements DeviceModel {
  name: string = 'NA87 PRO'
  support: SupportData = {
    IsSupportMagnet: true,
    Limit: {
      DpiLen: 0,
      KeySetLen: 0,
      KeysColorLen: 0,
      MacroBytesLen: 256,
      MacroIndexLen: 16,
      MagnetLen: 87,
      MacroPrefix: [],
    },
  }
}
class mu68Model implements DeviceModel {
  name: string = 'Mu68 PRO'
  support: SupportData = {
    IsSupportMagnet: true,
    Limit: {
      DpiLen: 0,
      KeySetLen: 0,
      KeysColorLen: 0,
      MacroBytesLen: 256,
      MacroIndexLen: 16,
      MagnetLen: 68,
      MacroPrefix: [],
    },
  }
}
class nd63Model implements DeviceModel {
  name: string = 'ND63'
  support: SupportData = {
    IsSupportMagnet: true,
    Limit: {
      DpiLen: 0,
      KeySetLen: 0,
      KeysColorLen: 0,
      MacroBytesLen: 256,
      MacroIndexLen: 16,
      MagnetLen: 64,
      MacroPrefix: [],
    },
  }
}
class polar75Model implements DeviceModel {
  name: string = 'polar75'
  support: SupportData = {
    IsSupportMagnet: true,
    Limit: {
      DpiLen: 0,
      KeySetLen: 0,
      KeysColorLen: 0,
      MacroBytesLen: 256,
      MacroIndexLen: 16,
      MagnetLen: 75,
      MacroPrefix: [],
    },
  }
}

class nd68Model implements DeviceModel {
  name: string = 'nd68'
  support: SupportData = {
    IsSupportMagnet: true,
    Limit: {
      DpiLen: 0,
      KeySetLen: 0,
      KeysColorLen: 0,
      MacroBytesLen: 128,
      MacroIndexLen: 64,
      MagnetLen: 68,
      MacroPrefix: [],
    },
  }
}

class he6UltraModel implements DeviceModel {
  name: string = 'HE6 Ultra'
  support: SupportData = {
    IsSupportMagnet: false,
    Limit: {
      DpiLen: 8,
      KeySetLen: 0,
      KeysColorLen: 0,
      MacroBytesLen: 140,
      MacroIndexLen: 6,
      MacroPrefix: [],
      MagnetLen: 0,
    },
  }
}
class JingTaiV2Model implements DeviceModel {
  name: string = 'JingTai V2' // 没实际意义
  support: SupportData = {
    IsSupportMagnet: true,
    Limit: {
      DpiLen: 0, // TODO: 待确认正确值
      KeySetLen: 0,
      KeysColorLen: 0,
      MacroBytesLen: 256,
      MacroIndexLen: 16,
      MacroPrefix: [],
      MagnetLen: 126,
    },
  }
}

class FE87V2Model implements DeviceModel {
  name: string = 'FE87 V2'
  support: SupportData = {
    IsSupportMagnet: false,
    Limit: {
      DpiLen: 0,
      KeySetLen: 0,
      KeysColorLen: 0,
      MacroBytesLen: 256,
      MacroIndexLen: 15,
      MagnetLen: 87,
      MacroPrefix: [],
    },
  }
}

class FE87V2ProModel implements DeviceModel {
  name: string = 'FE87 V2 Pro'
  support: SupportData = {
    IsSupportMagnet: true,
    Limit: {
      DpiLen: 0,
      KeySetLen: 0,
      KeysColorLen: 0,
      MacroBytesLen: 256,
      MacroIndexLen: 15,
      MagnetLen: 87,
      MacroPrefix: [],
    },
  }
}

class Mer68SESelfDevModel implements DeviceModel {
  name: string = 'Mer68SE SelfDev'
  support: SupportData = {
    IsSupportMagnet: true,
    Limit: {
      DpiLen: 0,
      KeySetLen: 0,
      KeysColorLen: 0,
      MacroBytesLen: 256,
      MacroIndexLen: 15,
      MagnetLen: 87,
      MacroPrefix: [],
    },
  }
}

class FE87V2MuYanModel implements DeviceModel {
  name: string = 'FE87 V2 MuYan'
  support: SupportData = {
    IsSupportMagnet: false,
    Limit: {
      DpiLen: 0,
      KeySetLen: 0,
      KeysColorLen: 0,
      MacroBytesLen: 240,
      MacroIndexLen: 8,
      MagnetLen: 0,
      MacroPrefix: [],
    },
  }
}

class MG63Model implements DeviceModel {
  name: string = 'MG63'
  support: SupportData = {
    IsSupportMagnet: true,
    Limit: {
      DpiLen: 0,
      KeySetLen: 0,
      KeysColorLen: 0,
      MacroBytesLen: 256,
      MacroIndexLen: 15,
      MagnetLen: 87,
      MacroPrefix: [],
    },
  }
}

const he3ModelIns = new he3Model()
const na87ModelIns = new na87Model()
const mu68ModelIns = new mu68Model()
const nd63ModelIns = new nd63Model()
const polar75ModelIns = new polar75Model()
const nd68ModelIns = new nd68Model()
const he6UltraModelIns = new he6UltraModel()
const jingtaiV2Ins = new JingTaiV2Model()
const FE87V2ModelIns = new FE87V2Model()
const FE87V2ProModelIns = new FE87V2ProModel()
const mer68SESelfDevModelIns = new Mer68SESelfDevModel()
const MG63ModelIns = new MG63Model()
const FE87V2MuYanIns = new FE87V2MuYanModel()

// export const usageToDeviceMode: { [key: number]: DeviceConnectMode } = {
//   16: DeviceConnectMode.M_USB,
//   17: DeviceConnectMode.Wireless24G
// };

// 设备模式
export const deviceMode: { [key: DefineDevice]: DeviceConnectMode } = {
  [VirtualHE3SEWireless]: DeviceConnectMode.M_USB,
  [VirtualHE3SEWireless_24g]: DeviceConnectMode.Wireless24G,
  [VirtualMars68ProWireless]: DeviceConnectMode.M_USB,
  [VirtualMars68ProWireless_24g]: DeviceConnectMode.Wireless24G,
  [VirtualMars68Wireless]: DeviceConnectMode.M_USB,
  [VirtualMars68Wireless_24g]: DeviceConnectMode.Wireless24G,

  [VirtualMonsGeek_NoLight]: DeviceConnectMode.M_USB,
  [VirtualMonsGeek_NoLight_24g]: DeviceConnectMode.Wireless24G,

  [VirtualMg68Max]: DeviceConnectMode.M_USB,
  [VirtualMg68Max_24g]: DeviceConnectMode.Wireless24G,

  [VirtualHe6Ultra]: DeviceConnectMode.M_USB,
  [VirtualHe6Ultra_24g]: DeviceConnectMode.Wireless24G,

  [VirtualMG68ACE_W]: DeviceConnectMode.M_USB,
  [VirtualMG68ACE_W_24g]: DeviceConnectMode.Wireless24G,

  [VirtualIrokFe87V2]: DeviceConnectMode.M_USB,
  [VirtualIrokFe87V2_24g]: DeviceConnectMode.Wireless24G,

  [VirtualIrokFe87V2IMC]: DeviceConnectMode.M_USB,
  [VirtualIrokFe87V2IMC_24g]: DeviceConnectMode.Wireless24G,

  [VirtualIrokFe87V2C18]: DeviceConnectMode.M_USB,
}

// 定义设备和模型实例的映射表
const deviceModelMap: { [key in DefineDevice]: DeviceModel } = {
  [VirtualHE3SEWireless_24g]: he3ModelIns,
  [VirtualHE3SEWireless]: he3ModelIns,
  [VirtualNa87ProWired]: na87ModelIns,
  [VirtualMu68Pro]: mu68ModelIns,
  [VirtualMu68Pro_Cyan]: mu68ModelIns,
  [VirtualMu68_ULTRA]: mu68ModelIns,
  [VirtualPolar75]: polar75ModelIns,
  [VirtualNd63]: nd63ModelIns,
  [VirtualNd63_Cyan]: nd63ModelIns,
  [VirtualHe6Ultra]: he6UltraModelIns,
  [VirtualHe6Ultra_24g]: he6UltraModelIns,
  [VirtualIrokFe87V2]: FE87V2ModelIns,
  [VirtualIrokFe87V2_24g]: FE87V2ModelIns,
  [VirtualMer68SESelfDev]: mer68SESelfDevModelIns,
  [VirtualIrokFe87V2IMC]: FE87V2ProModelIns,
  [VirtualIrokFe87V2IMC_24g]: FE87V2ProModelIns,
  [VirtualIrokFe87V2C18]: FE87V2ModelIns,
}
RoYuanDevice.forEach((device) => (deviceModelMap[device] = nd68ModelIns))
;[...JingTaiMg75Devices, ...JingTaiMer68Devices].forEach((device) => (deviceModelMap[device] = polar75ModelIns))
JingTaiV2Devices.forEach((device) => (deviceModelMap[device] = jingtaiV2Ins))
HuoChaiRenDevices.forEach((device) => (deviceModelMap[device] = MG63ModelIns))
ZhiHuiWuXian_Device.forEach((device) => (deviceModelMap[device] = FE87V2MuYanIns))

// 导出 deviceMap
export const deviceMap: { [key: DefineDevice]: DeviceModel } = deviceModelMap as { [key: DefineDevice]: DeviceModel }
